<template>
  <div class="certificate">
    <BackCurrent v-if="appVersion === 'dd'" title="证书申请" :defaultBack="false" @on-back="handleBack" />
    <div class="container">
      <div class="head">
        <div class="left-head">
          <div class="left-head-item" :class="{current: active === 1}" @click="handleChangeActive(1)">
            <span>可申请({{ applyList.length }})</span>
            <i></i>
          </div>
          <div class="left-head-item" :class="{current: active === 2}" @click="handleChangeActive(2)">
            <span>已获得({{ obtain.length }})</span>
            <i></i>
          </div>
        </div>
        <!-- <div class="right-head" @click="handleRefresh">
          <i class="iconfont iconicon-refresh-right" v-if="synStatus"></i>
          <span>{{ synStatus | synText }}</span>
        </div> -->
      </div>

      <section class="apply" v-show="active === 1">
        <template v-if="applyHas === true">
          <section class="apply-item" v-for="item in applyList" :key="item.event_info_id">
            <div class="apply-item-header">
              <div class="apply-item-header-left">
                <img :src="videoCdn + item.event_pic" alt="" />
              </div>
              <div class="apply-item-header-right">
                <div class="title p2-overflow">{{ item.event_name }}</div>
                <span class="sign" v-if="item.type == '2'">已签到</span>
              </div>
            </div>
            <div class="apply-item-sign" v-if="item.type == '2'">
              <p class="tips">您已经有效签到，可以获得该课程的满学时</p>
              <div class="sign-info">
                <span class="sign-info-hour">{{ item.maxClassHour }}学时</span>
                <div class="apply-btn" v-if="item.examine_result == 8060">等待发放</div>
                <div
                  class="apply-btn"
                  v-if="item.examine_result == 8066 || item.examine_result == 8062 || item.examine_result == 8063"
                  @click="handleApply(item, 2)"
                >
                  申请证书
                </div>
              </div>
            </div>
            <div class="apply-item-footer">
              <div class="time">
                <span class="live-time">直播观看 {{ item.live_study_time | watch_record_format }}</span>
                <span class="record-time">点播观看 {{ item.record_study_time | watch_record_format }}</span>
              </div>
              <div class="handler">
                <span>预计学时 {{ item.userClassHour }}</span>
                <div class="operate">
                  <div class="apply-btn" @click="handleGoDetail(item.event_info_id)">观看详情</div>
                  <div class="apply-btn current" v-if="item.examine_result == 8060">等待发放</div>
                  <div
                    class="apply-btn current"
                    v-if="item.examine_result == 8066 || item.examine_result == 8062 || item.examine_result == 8063"
                    @click="handleApply(item, 1)"
                  >
                    申请证书
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- <section class="apply-item" v-for="item in applyList" :key="item.event_info_id">
            <div class="apply-top">
              <div class="avatar">
                <img :src="videoCdn + item.event_pic" alt="" />
              </div>
              <div class="title">{{ item.event_name }}</div>
            </div>
            <div class="apply-bottom">
              <div class="time">
                <span class="live-time">直播观看 {{ item.live_study_time | watch_record_format }}</span>
                <span class="record-time">点播观看 {{ item.record_study_time | watch_record_format }}</span>
              </div>
              <p class="study-time">预计学时 {{ item.userClassHour }}</p>
              <div class="operate">
                <button class="btn-confrim" @click="handleGoDetail(item.event_info_id)">观看详情</button>
                <button class="btn-wait" v-if="item.examine_result == 8060">等待发放</button>
                <button
                  class="btn-confrim"
                  v-if="item.examine_result == 8066 || item.examine_result == 8062"
                  @click="handleApply(item)"
                >
                  申请证书
                </button>
              </div>
            </div>
          </section> -->
        </template>

        <template v-if="applyHas === false">
          <empty />
        </template>
      </section>

      <section class="obtain" v-show="active === 2">
        <template v-if="obtain.length > 0">
          <section class="obtain-item" v-for="(item, index) in obtain" :key="index">
            <div class="obtain-top">
              <div class="avatar">
                <img :src="videoCdn + item.event_pic" alt="" />
              </div>
              <div class="title">
                {{ item.event_name }}
              </div>
            </div>
            <div class="obtain-bottom">
              <span class="info">已发放学时 {{ item.userClassHour }}</span>
              <div class="look" @click="handleLookApplyBook(item)">查看证书</div>
            </div>
          </section>
        </template>
        <template v-else>
          <empty />
        </template>
      </section>

      <!-- <template v-else>
        <p class="tips-a">您还未填写科目信息，请完善科目信息后再申请证书</p>
        <div class="come-study" @click="handleGoUserInfo">去完善信息</div>
      </template> -->
      <info-not :infoNotShow="infoNotShow" :infoText="infoText" @CloseNot="handleCloseNot"></info-not>

      <!-- 申请证书之信息全的情况 -->
      <apply-box
        :applyBoxShow="applyBoxShow"
        :info="applyBoxInfo"
        :applyType="applyType"
        @CloseApply="handleCloseApply"
        @applySuccess="handleApplySuccess"
        @need-refresh="handleNeedRefresh"
      ></apply-box>

      <!-- 申请证书之科目不对 -->
      <test-sub-box
        :subBoxShow="subBoxShow"
        @CloseSub="handleCloseSub"
        :text="text"
        :id="item_id"
        :subjectName="subjectName"
        :userSubjects="userSubjects"
        :applyType="applyType"
      ></test-sub-box>

      <reload-box :refreshShow="refreshShow" @refresh="handleRefresh"></reload-box>

      <look-book :show="lookBookShow" @CloseBook="handleCloseBook"></look-book>

      <success-box :successShow="successShow"></success-box>

      <apply-popup :show="applyPopupShow" @on-affirm="handleAffirm"></apply-popup>
    </div>
  </div>
</template>

<script>
import BackCurrent from '@/components/back-current'
import ApplyBox from './components/applyBox'
import SuccessBox from './components/successBox'
import TestSubBox from './components/testSubBox'
import InfoNot from './components/infoNot'
import LookBook from './components/lookBook'
import Empty from '@/components/empty'
import ReloadBox from './components/reloadBox'
import applyPopup from './components/applyPopup.vue'
import {checkNameAndSub, applyAndAwarded, synOldCertByUser} from '@/api/dd'
import {getUser} from '@/api/index'
export default {
  name: 'certificate',
  components: {
    BackCurrent,
    Empty,
    // Back,
    ApplyBox,
    SuccessBox,
    TestSubBox,
    InfoNot,
    LookBook,
    ReloadBox,
    applyPopup
  },
  data() {
    return {
      isUserSub: null,
      active: 1,
      applyBoxShow: false,
      applyBoxInfo: {},
      applyList: [],
      applyHas: null,
      obtain: [],
      infoText: '',
      infoNotShow: false,
      subBoxShow: false,
      item_id: '',
      text: '',
      subjectName: '',
      userSubjects: [],
      lookBookShow: false,
      successShow: false,
      style: '',
      userName: '',
      regex: '',
      refreshShow: false,
      synStatus: null,
      applyType: 2,
      applyPopupShow: false
    }
  },
  watch: {
    infoNotShow(newV) {
      this.maskStopScroll(newV)
    },
    applyBoxShow(newV) {
      this.maskStopScroll(newV)
    },
    subBoxShow(newV) {
      this.maskStopScroll(newV)
    }
  },
  filters: {
    synText(val) {
      switch (val) {
        case 0:
          return '未同步'
        case 1:
          return '同步中'
        case 2:
          return '已同步'
        case 3:
          return '同步失败'
      }
    }
  },
  methods: {
    handleBack() {
      this.$router.replace('/home')
    },
    maskStopScroll(newV) {
      if (newV) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = 'auto'
      }
    },
    // 验证用户名是否正常
    handleCheckName() {
      checkNameAndSub().then(res => {
        if (res.msg === 'OK!') {
          this.isUserSub = true
          this.infoText = res.msg
        } else {
          this.infoText = res.msg
          this.isUserSub = false
        }
      })
    },
    // 获取data
    initData() {
      applyAndAwarded().then(res => {
        if (res.code === 0 && res.success) {
          this.obtain = res.data.awarded
          this.synStatus = res.data.synStatus
          if (res.data.mayApply && res.data.mayApply.length > 0) {
            this.applyHas = true
            this.applyList = res.data.mayApply.map(item => {
              const userSubs = item.userSubjects
              if (!item.examine_result) {
                item.examine_result = 8066 // 待申请
              }
              userSubs.forEach(sub => {
                // 若用户科目符合当前科目
                if (item.subjectName === sub.subjectName) {
                  item.sub = true
                }
              })
              return item
            })
          } else {
            this.applyHas = false
          }
        }
      })
    },
    initUserInfo() {
      getUser().then(res => {
        if (res.code === 0 && res.success) {
          this.userName = res.data.name
        }
      })
    },
    // 切换tab
    handleChangeActive(num) {
      this.$router.replace({
        path: '/certificate/index',
        query: {
          index: num
        }
      })
      this.active = num
    },
    // 打开申请证书
    handleApply(item, type) {
      this.applyPopupShow = true

      // console.log('item', item)
      // else if (item.subjectName === '综合') {
      //   // 5. 后面加的 个人信息是符合课程科目的 四川教科院 “综合科目” 标签的活动，不判断科目，可以直接获得学时
      //   this.applyBoxInfo = item
      //   this.applyBoxShow = true
      // }
      this.applyType = type
      if (!/^[\u4e00-\u9fa5]{2,15}$/.test(this.userName)) {
        this.infoText = '你的姓名异常'
        this.infoNotShow = true
        return false
      } else if (!this.isUserSub) {
        // 1. 判断姓名不正常或者科目为空, 跳转到用户信息修改页面
        this.infoNotShow = true
        return false
      } else if (item.labels) {
        // 5. 后面加的 个人信息是符合课程科目的 四川教科院 “综合科目” 标签的活动，不判断科目，可以直接获得学时
        this.applyBoxInfo = item
        this.applyBoxShow = true
      } else if (item.sub) {
        // 3. 个人信息是符合课程科目的
        this.applyBoxInfo = item
        this.applyBoxShow = true
        return false
      } else if (!item.sub) {
        // 4. 若观看科目和用户科目不符合
        this.item_id = item.event_info_id
        this.text = item.text
        this.subjectName = item.subjectName
        this.userSubjects = item.userSubjects
        this.subBoxShow = true
        return false
      } else if (!item.subjectName && this.isUserSub) {
        // 2. 若没有科目
        this.item_id = item.event_info_id
        this.text = item.text
        this.subjectName = item.subjectName
        this.userSubjects = item.userSubjects
        this.subBoxShow = true
        return false
      }
    },
    // 关闭申请证书
    handleCloseApply() {
      this.applyBoxShow = false
    },
    // 关闭科目信息框
    handleCloseSub() {
      document.body.style.overflow = 'auto'
      this.subBoxShow = false
    },
    handleCloseNot() {
      this.infoNotShow = false
    },
    // 观看详情
    handleGoDetail(id) {
      this.$router.push(`/certificate/detail/${id}`)
    },
    // 查看证书
    handleLookApplyBook(item) {
      if (!item.cert_id) {
        this.$router.push(`/certificate/look/${item.apply_id}?cert_id=null&last_revoke_time=${item.last_revoke_time}`)
      } else {
        this.$router.push(
          `/certificate/look/${item.apply_id}?cert_id=${item.cert_id}&last_revoke_time=${item.last_revoke_time}`
        )
      }
      // window.location.href = 'https://jjzm.k12top.com/#/login'
    },
    handleCloseBook() {
      this.lookBookShow = false
    },
    // 申请成功
    handleApplySuccess() {
      this.successShow = true
      setTimeout(() => {
        this.applyBoxShow = false
        this.successShow = false
        this.initData()
      }, 2000)
    },
    // 显示刷新box
    handleNeedRefresh() {
      this.refreshShow = true
    },
    handleRefresh() {
      if (this.synStatus === 1) return
      synOldCertByUser().then(res => {
        if (res.code === 0) {
          this.handleCreate()
        }
      })
    },
    // 获取滚动值
    getScrollTop() {
      document.addEventListener('scroll', () => {
        window.consoole.log(window.scrollY)
      })
    },
    handleCreate() {
      this.handleCheckName()
      this.initData()
      this.initUserInfo()
    },
    handleAffirm() {
      this.applyPopupShow = false
    }
  },
  mounted() {
    this.active = this.$route.query.index ? Number(this.$route.query.index) : 1
    this.innerHeight = window.innerHeight
    this.handleCreate()
  },
  beforeDestroy() {
    document.body.style.overflow = 'auto'
  }
}
</script>

<style lang="scss" scoped>
.certificate {
  width: 100%;
  .container {
    width: 100%;
    padding: 12px 16px;
    box-sizing: border-box;
    .head {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .left-head {
        display: flex;
        flex-direction: row;
        align-items: center;
        .left-head-item {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          &:last-child {
            margin-left: 32px;
          }
          &.current {
            span {
              color: #303133;
            }
            i {
              opacity: 1;
            }
          }
          span {
            font-size: 14px;
            color: #909399;
          }
          i {
            margin-top: 10px;
            display: inline-block;
            width: 32px;
            height: 5px;
            background-color: #4465f3;
            border-radius: 2.5px;
            opacity: 0;
          }
        }
      }
      .right-head {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 14px;
        height: 20px;
        i,
        span {
          color: #909399;
        }
        i {
          margin-right: 5px;
        }
      }
    }
    .apply {
      margin-top: 20px;
      width: 100%;
      height: auto;
      .apply-item {
        margin-bottom: 12px;
        width: 100%;
        padding: 12px;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 8px;
        .apply-item-header {
          display: flex;
          align-items: flex-start;
          .apply-item-header-left {
            flex: 0 0 132px;
            height: 74px;
            img {
              width: 100%;
              height: 100%;
              border-radius: 6px;
            }
          }
          .apply-item-header-right {
            margin-left: 12px;
            .title {
              font-size: 15px;
              color: #1a1a1a;
            }
            .sign {
              display: inline-block;
              margin-top: 9px;
              padding: 1px 3px;
              box-sizing: border-box;
              /* width: 42px; */
              /* height: 20px; */
              text-align: center;
              background: #ebfff1;
              color: #0eab5d;
              border: 1px solid #5fd994;
              border-radius: 2px;
            }
          }
        }
        .apply-item-sign {
          width: 100%;
          padding-bottom: 20px;
          box-sizing: border-box;
          border-bottom: 1px solid #e6e6e6;
          .tips {
            color: #4d4d4d;
            font-size: 14px;
          }
          .sign-info {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 14px;
            .sign-info-hour {
              color: #ff953a;
            }
          }
        }
        .apply-btn {
          width: 84px;
          height: 30px;
          text-align: center;
          line-height: 30px;
          background: rgba(68, 101, 243, 0.08);
          color: #4465f3;
          border-radius: 40px;
          &.current {
            margin-left: 12px;
          }
        }
        .apply-item-footer {
          margin-top: 20px;
          width: 100%;
          font-size: 14px;
          color: #4d4d4d;
          .time {
            span {
              margin-right: 14px;
            }
          }
          .handler {
            margin-top: 12px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            span {
              color: #ff953a;
            }
            .operate {
              display: flex;
              align-items: center;
            }
          }
        }
      }
      /* .apply-item {
        margin-bottom: 16px;
        width: 100%;
        background: #fff;
        border-radius: 12px;
        box-shadow: 0px 0px 12px 0px rgba(23, 38, 71, 0.04);
        .apply-top {
          display: flex;
          width: 100%;
          padding: 16px 14px;
          box-sizing: border-box;
          .avatar {
            flex: 0 0 132px;
            width: 132px;
            height: 74px;
            border-radius: 6px;
            img {
              width: 100%;
              height: 74px;
              border-radius: 6px;
            }
          }
          .title {
            margin-left: 16px;
            color: #303133;
            font-weight: 700;
            font-size: 14px;
            line-height: 22px;
          }
        }
        .apply-bottom {
          width: 100%;
          padding: 16px 14px;
          box-sizing: border-box;
          border-top: 1px solid #e7e9ef;
          .time {
            display: flex;
            .live-time,
            .record-time {
              font-size: 13px;
              line-height: 24px;
              color: #909399;
            }
            .record-time {
              margin-left: 30px;
            }
          }
          .study-time {
            font-size: 13px;
            color: #909399;
            line-height: 24px;
          }
          .operate {
            margin-top: 12px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            button {
              margin: 0 8px;
              border: none;
              padding: 8px 16px;
              border-radius: 15px;
              outline: none;
              &.btn-confrim {
                background: rgba(74, 134, 246, 0.12);
                color: #4465f3;
              }
              &.btn-wait {
                color: #909399;
              }
            }
          }
        }
      } */
    }
    .obtain {
      margin-top: 20px;
      width: 100%;
      height: auto;
      .obtain-item {
        margin-bottom: 16px;
        width: 100%;
        background: #fff;
        border-radius: 12px;
        box-shadow: 0px 0px 12px 0px rgba(23, 38, 71, 0.04);
        .obtain-top {
          display: flex;
          width: 100%;
          padding: 16px 14px;
          box-sizing: border-box;
          .avatar {
            flex: 0 0 132px;
            width: 132px;
            height: 74px;
            border-radius: 6px;
            img {
              width: 100%;
              height: 74px;
              border-radius: 6px;
            }
          }
          .title {
            margin-left: 16px;
            color: #303133;
            font-weight: 700;
            font-size: 14px;
            line-height: 22px;
          }
        }
        .obtain-bottom {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          padding: 16px 14px;
          box-sizing: border-box;
          border-top: 1px solid #e7e9ef;
          .info {
            color: #909399;
            font-size: 13px;
          }
          .look {
            padding: 8px 16px;
            box-sizing: border-box;
            border-radius: 15px;
            background: rgba(74, 134, 246, 0.12);
            color: #4465f3;
          }
        }
      }
    }
  }
}
</style>
